var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4722 9.59692L7.84717 15.2219C7.68866 15.3804 7.47367 15.4695 7.24951 15.4695C7.02535 15.4695 6.81036 15.3804 6.65185 15.2219C6.49335 15.0634 6.4043 14.8484 6.4043 14.6243C6.4043 14.4001 6.49335 14.1851 6.65185 14.0266L11.6799 8.99997L6.65326 3.97192C6.57478 3.89344 6.51252 3.80026 6.47004 3.69772C6.42757 3.59517 6.4057 3.48526 6.4057 3.37427C6.4057 3.26327 6.42757 3.15336 6.47004 3.05082C6.51252 2.94827 6.57478 2.8551 6.65326 2.77661C6.73175 2.69812 6.82492 2.63587 6.92747 2.59339C7.03001 2.55091 7.13992 2.52905 7.25092 2.52905C7.36191 2.52905 7.47182 2.55091 7.57437 2.59339C7.67691 2.63587 7.77009 2.69812 7.84857 2.77661L13.4736 8.40161C13.5521 8.48009 13.6144 8.57331 13.6569 8.67592C13.6994 8.77853 13.7212 8.88851 13.721 8.99956C13.7209 9.11061 13.6989 9.22054 13.6561 9.32305C13.6134 9.42556 13.5509 9.51863 13.4722 9.59692Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/right.c7f6326c7d7e60a9dd6c67f68a31ff2a.svg";
export { ForwardRef as ReactComponent };